var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProhibitedIndustryGray = function SvgProhibitedIndustryGray(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83398 8.00032L4.24859 2.66699H6.15134L6.50065 7.61937",
    fill: "none",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.6663H3.5001C2.94777 14.6663 2.50004 14.2186 2.5001 13.6662L2.50053 9.08402C2.50041 8.94452 2.53959 8.80892 2.6119 8.69854C2.6642 8.61871 2.73168 8.55534 2.80834 8.51314C2.86644 8.48115 2.93325 8.47098 2.99927 8.46449L3.83951 8.38182L6.53186 8.11694L13.4021 7.44102C13.9902 7.38316 14.5 7.84524 14.5 8.43622V13.6663C14.5 14.2186 14.0523 14.6663 13.5 14.6663Z",
    stroke: "#595959",
    fill: "none",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27734 1.64311C12.4046 3.40533 13.1668 1.29785 13.1668 1.29785",
    fill: "none",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30599 11.7246H4.47266",
    stroke: "#595959",
    fill: "none",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65365 11.7246H6.82031",
    stroke: "#595959",
    fill: "none",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 12.7021C9.16602 11.5976 9.91221 10.7021 10.8327 10.7021C11.7532 10.7021 12.4993 11.5976 12.4993 12.7021V14.7021H9.16602V12.7021Z",
    fill: "none",
    stroke: "#595959",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProhibitedIndustryGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "prohibited-industry-gray.f7909fe361ae9b1a9e04181e607c52df.svg";